
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"41.592"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.532 0a2.509 2.509 0 00-2.5 2.5v13.05a.852.852 0 000 .494V36.6a2.509 2.509 0 002.5 2.5v.832a1.675 1.675 0 001.664 1.664h2.5a1.675 1.675 0 001.664-1.664V39.1h13.31v.832a1.675 1.675 0 001.664 1.664h2.5a1.675 1.675 0 001.664-1.664V39.1a2.509 2.509 0 002.5-2.5V15.961a.845.845 0 000-.338V2.5a2.509 2.509 0 00-2.5-2.5zm0 1.664h24.955a.821.821 0 01.832.832v12.477H1.7V2.5a.821.821 0 01.832-.836zm3.249 3.3a.972.972 0 00-.1.026.833.833 0 00-.65.832v5.823a.832.832 0 101.664 0V5.823a.833.833 0 00-.91-.858zM1.7 16.637h26.619V36.6a.821.821 0 01-.832.832H2.532A.821.821 0 011.7 36.6zm4.081 2.47a.972.972 0 00-.1.026.833.833 0 00-.65.832v5.823a.832.832 0 101.664 0v-5.824a.833.833 0 00-.91-.858zM4.196 39.1h2.5v.832h-2.5zm19.132 0h2.5v.832h-2.5z","fill":"#38470b"}})])
          )
        }
      }
    